import { getLanguageParam } from '@sportal365/smp-widget-utils';
import { SDKOptions } from '../../types';
import { generateRequest } from '../http.service';
import { IStandingsCompetitionDetailsResponse } from '../../types/standings';
export interface IStandingsProps {
  stage_id?: string;
  coverage_type?: string;
  group_id?: string;
  filter?: string;
  home_away?: string;
  limit?: string;
  offset?: string;
  sport: string;
}

export const getStandings = async ({ params, sdkOptions }: { params: IStandingsProps; sdkOptions: SDKOptions }) => {
  const url = `${sdkOptions.dataConfigStandingsApiUrl}/standings/${params.sport}`;

  const baseParams = {
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
    optional_data: 'FORM',
    stage_id: params.stage_id,
    coverage_type: params.coverage_type,
    filter: params.filter,
    home_away: params.home_away,
    row_limit: params.limit,
    row_offset: params.offset,
    sport: params.sport,
  };

  return await generateRequest(url, baseParams, sdkOptions);
};

export interface IStandingsCompetitionProps {
  competition_id?: string;
  sport?: string;
}

export const getStandingsCompetitionDetails = async ({
  params,
  sdkOptions,
}: {
  params: IStandingsCompetitionProps;
  sdkOptions: SDKOptions;
}): Promise<IStandingsCompetitionDetailsResponse> => {
  const url = `${sdkOptions.dataConfigStandingsApiUrl}/${params.sport}/v2/seasons/available`;

  const baseParams = {
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
    competition_id: params.competition_id,
    sport: params.sport,
  };

  return await generateRequest(url, baseParams, sdkOptions);
};
